import { atom, useAtom } from 'jotai';
import {
  checkHasAuthToken,
  getAuthCredentials,
  removeAuthToken,
  setAuthCredentials,
} from '@/data/client/token.utils';
import { HttpClient } from '@/data/client/http-client';
import routes from '@/config/routes';

const authorizationAtom = atom(checkHasAuthToken());

export default function useAuth() {
  const [isAuthorized, setAuthorized] = useAtom(authorizationAtom);

  const googleLogin = async (accessToken: string) => {
    try {
      const response = await HttpClient.post(routes.socialLoginToken, {
        provider: 'google',
        access_token: accessToken,
      });

      const { token, permissions } = response as { token: string; permissions: string[] };
      setAuthCredentials(token, permissions);
      setAuthorized(true);
      return { token, permissions, success: true };
    } catch (error) {
      console.error('Google login failed:', error);
      return { success: false, error };
    }
  };

  return {
    setToken: setAuthCredentials,
    getToken: getAuthCredentials,
    isAuthorized,
    authorize(token: string, permissions: string[]) {
      setAuthCredentials(token, permissions);
      setAuthorized(true);
    },
    unauthorize() {
      setAuthorized(false);
      removeAuthToken();
    },
    googleLogin,
  };
}